<template>
  <div v-bind:class="{ 'Mobile' : isMobile , 'Dealsheet' : hideHeader}">
    <div id='overlay' v-if='loadingCust'>
    </div>
    <div v-if='!error'>
      <ul class="nav nav-tabs panel-level-tabs d-flex flex-nowrap" v-if='!hideHeader'>
        <li class="nav-item title-tab">
          <a class="nav-link active" href="#">
            <strong>Customer Dashboard</strong>
          </a>
        </li>
        <li class="nav-item" v-for='entity in assosciatedIds.EntityList' :key='entity.EntityID'>
          <a class="nav-link" target='_blank' :href="getDealsheetUrl(entity.EntityID)">
            <span class="hidden-mobile">{{entity.MakeName}} {{entity.ModelName}}</span>
            <alerts-block v-if="!isMobile" :alert-entity='entity' />
            <b>{{entity.EntityScore}}</b>
          </a>
        </li>
      </ul>
      <div id="customer-profile" class="container-fluid px-0 scroll-y">
        <div class="panel-toolbar d-flex sticky-top bg-white px-3 pt-2 pb-0">
          <plugin-site-nav v-if="isMobile" />
          <h5 class="text-steel" v-if='customerInfo'>{{customerInfo.CustomerName | capitalize}}</h5>
        </div>
        <div class="pt-0 pb-0 px-4 bb-1" v-if='!hideHeader'>
          <div class="row">
            <div class="col-6">
              <div v-if='showSocial'>
                <small>Social:</small>
                <br/>
                <div style='height: 20px;'>
                  <social-media v-if='customerInfo' :customer-obj='customerInfo'></social-media>
                </div>
              </div>
            </div>
            <div class="responsive-btns col-6 d-flex justify-content-end">
              <button class="btn btn-white text-primary" @click='startMessage()'>
                <img src="static/assets/img/SVGIcons/icon-add-messages.svg" class="m-2" />
              </button>
              <!-- <button class="btn btn-white text-primary">
              <img src="static/assets/img/SVGIcons/icon-add-processes.svg" class="m-2" />
            </button> -->
            </div>
          </div>
          <div class="row">
            <div class="p-2">
              <h6 class="mb-0">ENGAGEMENT: &nbsp;
                <engangement-icons :customer-obj='customerInfo'></engangement-icons>
              </h6>
            </div>
          </div>

        </div>
        <div class="bb-3 border-primary responsive-tabs sticky-top top-32 bg-white">
          <b-nav tabs fill>
            <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Profile" v-on:click="switchTab(NavTabs.Profile)" title='Profile'>
              <img src="static/assets/img/SVGIcons/icon-current-customer.svg" class="m-2" />
              <br/> Customer Info
            </b-nav-item>
            <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Messages" v-on:click="switchTab(NavTabs.Messages)" title='Messages'>
              <img src="static/assets/img/SVGIcons/icon-messages.svg" class="m-2" />
              <br/> Messages
            </b-nav-item>
            <!-- <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Processes" v-on:click="switchTab(NavTabs.Processes)" title='Processes'>
            <img src="static/assets/img/MainNavIcons/icon-processes-blue.svg" class="icon-image icon-lg" /> <br/>
            Processes
          </b-nav-item> -->
            <!-- <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Search" v-on:click="switchTab(NavTabs.Search)" title='Search'>
            <img src="static/assets/img/MainNavIcons/icon-processes-blue.svg" class="icon-image icon-lg" /> <br/>
            Search
          </b-nav-item> -->
            <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Reviews" v-on:click="switchTab(NavTabs.Reviews)" title='Reviews'
              v-if='assosciatedIds.ReviewCount > 0'>
              <img src="static/assets/img/SVGIcons/icon-reviews.svg" class="m-2" />
              <br/> Reviews
            </b-nav-item>
            <b-nav-item v-bind:active="customerContentTabIndex == NavTabs.Signals" v-on:click="switchTab(NavTabs.Signals)" title='Signals'
              v-if='assosciatedIds.EngagementCount > 0'>
              <img src="static/assets/img/SVGIcons/icon-engagement.svg" class="m-2" />
              <br/> Engagement
            </b-nav-item>
          </b-nav>
        </div>

        <div id="" class="content-wrap" v-if='!loading'>
          <customer-info v-if="customerContentTabIndex == NavTabs.Profile" />
          <customer-reviews v-if="customerContentTabIndex == NavTabs.Reviews" class="content" />
          <customer-signals id="" v-if="customerContentTabIndex == NavTabs.Signals" class="content" />
          <div id="" v-show="customerContentTabIndex == NavTabs.Messages" class="content">
            <div class="container-fluid" v-if='!isMobile'>
              <div class='row'>
                <div class='col-sm-6 col-md-6 col-lg-6 col-xl-4 border-right p-0'>
                  <group-list :can-create-group='belongsToAccount' :selected-group-id="selectedGroupId" :groups='sortedGroups' @clickgroup='groupClick($event)'
                    @newgroup='handleNewGroup()'></group-list>
                </div>
                <div class='col-sm-6 col-md-6 col-lg-6 col-xl-8  p-0'>
                  <messenger v-show='!showGroupCreate' :passed-group='selectedGroup' :user='user' @groupupdated='handleGroupUpdate($event)'
                    @gotgrouphistory='handleGroupUpdate($event)' />
                  <create-group @groupcreated='handleGroupCreated($event)' :customer-identifiers='assosciatedIds' @quitcreategroup='handleQuitCreateGroup()'
                    v-if='showGroupCreate'></create-group>
                </div>
              </div>
            </div>
            <div v-else-if="isMobile">
              <div v-show='showMobileGroup'>
                <group-list :can-create-group='belongsToAccount' :groups='sortedGroups' :selected-group-id="selectedGroupId" @clickgroup='mobileGroupClick($event)'
                  @newgroup='mobileNewGroup()'></group-list>
              </div>
              <div v-show='!showMobileGroup'>
                <div @click='showMobileGroup = true' class='actionable'>
                  <i class='fa fa-chevron-left'></i>
                  <span v-if='selectedGroup'>&nbsp;{{showGroupCreate ? 'Create Group' : selectedGroup.GroupName}}</span>
                </div>
                <messenger v-show='!showGroupCreate' :passed-group='selectedGroup' :user='user' @groupupdated='handleGroupUpdate($event)'
                  @gotgrouphistory='handleGroupUpdate($event)'></messenger>
                <create-group v- :customer-identifiers='assosciatedIds' @quitcreategroup='handleMobileQuitCreateGroup()' v-if='showGroupCreate'></create-group>
              </div>
            </div>

          </div>
          <div id="" v-if="customerContentTabIndex == NavTabs.Processes" class="content">
            Processes for the customer Tab
          </div>
          <div id="" v-if="customerContentTabIndex == NavTabs.Search" class="content">
            Search for the customer Tab
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class='card'>
        <div class='card-body'>
          <h5>Sorry we couldn't find the information you requested.</h5>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
  import {
    mapGetters
  } from "vuex";
  import {
    CustomerAPIClient
  } from '../../lib/data_access/Customer'
  import {
    aaPubnub
  } from '@/lib/pubnub/index'
  import {
    convertIdToPubNubKind,
    convertToMotoMessage,
    convertIdToMotoKind
  } from '@/lib/utilities/'

  import {
    EpochTicks,
    GroupMessagingType,
    ChannelType,
    WorkflowInstanceStatus,
    NotificationType
  } from '@/lib/utilities/enums';

  import moment from 'moment'
  import CustomerInfo from './CustomerInfo/CustomerInfo.vue'
  import CustomerReviews from './Reviews/CustomerReviews.vue'
  import CustomerSignals from './Signals/CustomerSignals.vue'
  import Messenger from '@/components/Messenger/Messenger.vue'
  import PluginSiteNav from '@/components/Nav/PluginSiteNav.vue'
  import AlertsBlock from '@/components/Icons/AlertsBlock.vue'
  import GroupList from '@/components/GroupList/GroupList.vue'
  import CreateGroup from '@/components/CreateGroup/CreateGroup.vue'
  import SocialMedia from '@/components/Icons/SocialMedia.vue'
  import EngangementIcons from '@/components/Icons/EngangementIcons.vue'
  import {
    GroupType
  } from '../../lib/utilities/enums';

  export default {
    name: "customerProfile",
    components: {
      CustomerInfo,
      CustomerReviews,
      CustomerSignals,
      Messenger,
      PluginSiteNav,
      AlertsBlock,
      GroupList,
      CreateGroup,
      SocialMedia,
      EngangementIcons
    },
    props: ['hideHeader', 'isMobile', 'customerObj', 'showMessage', 'user', 'initiateMessage'],
    data: function () {
      return {
        customerContentTabIndex: 0,
        NavTabs: {
          Profile: 0,
          Reviews: 1,
          Signals: 2,
          Messages: 3,
          Processes: 4
        },
        customerReviewsContentTabIndex: 1,
        accordion1: false,
        accordion2: null,
        accordion3: true,
        collapsed: true,
        customerInfo: {},
        assosciatedIds: {},
        loading: true,
        showMobileGroup: true,
        showGroupCreate: false,
        groups: [],
        pnInstance: {},
        selectedGroupId: null,
        loadingCust: true,
        error: false
      };
    },
    methods: {
      handleGroupUpdate: function (group) {
        let vm = this;
        let grpIndex = vm.groups.findIndex(function (element) {
          return element.GroupId == group.GroupId
        })

        if (grpIndex > -1) {
          vm.groups.splice(grpIndex, 1, group)
        }
      },
      listener: function (vendorInfo) {
        let vm = this
        return {
          status: function (status) {
            console.log(status)
          },
          message: function (message) {
            let channelName = message.actualChannel ? message.actualChannel : message.subscribedChannel;

            if (!channelName || !message.message)
              return;

            if (vm.pnInstance.vendorInfo.Channels.indexOf(channelName) >= 0) {
              handleControlMessage(message.message, vm.groups, vm.user);
            } else {
              handleRegularMessage(message, vm.groups)
            }
          },
          presence: function (presence) {
            console.log(presence)
          }
        }
      },
      switchTab: function (tabIndex) {
        let vm = this;
        if (tabIndex != vm.NavTabs.Messages) {
          vm.showGroupCreate = false;
        }
        vm.customerContentTabIndex = tabIndex;

      },
      getDealsheetUrl: function (entityId) {
        return process.env.DEALSHEET_URL + entityId;
      },
      mobileGroupClick(event) {
        let vm = this;
        vm.selectedGroupId = event.GroupId
        vm.showMobileGroup = false;
      },
      groupClick(event) {
        let vm = this;
        vm.selectedGroupId = event.GroupId
      },
      handleNewGroup() {
        let vm = this;
        vm.startMessage()
      },
      mobileNewGroup() {
        let vm = this;
        vm.showMobileGroup = false
        vm.showGroupCreate = true
      },
      handleQuitCreateGroup() {
        let vm = this;
        vm.showGroupCreate = false;
      },
      handleMobileQuitCreateGroup() {
        let vm = this;
        vm.showGroupCreate = false;
        vm.showMobileGroup = true;
      },
      startMessage() {
        let vm = this;
        if (vm.belongsToAccount) {
          vm.customerContentTabIndex = 3;
          vm.showGroupCreate = true;
        }
      },
      handleGroupCreated(grpResp) {
        let vm = this;
        vm.selectedGroupId = grpResp.MessageResponse.GroupId
        vm.showGroupCreate = false
      }
    },
    watch: {
      customerObj: {
        handler: function () {
          let vm = this;
          vm.error = false
          vm.loadingCust = true
          loadCustomer(vm).then(function () {
            vm.customerContentTabIndex = 0
            vm.loadingCust = false
          }).catch(function(error){
            vm.error = true
          })
        },
        deep: true
      },
      initiateMessage: function (newVal) {
        let vm = this;
        if (newVal) {
          if (vm.belongsToAccount) {
            vm.startMessage()
          }
        } else {
          vm.customerContentTabIndex = 0
        }
      }
    },
    created() {
      let vm = this;
      vm.loadingCust = true
      vm.pnInstance = aaPubnub.getInstance();
      vm.pnInstance.pubnub.addListener(vm.listener(vm.pnInstance.vendorInfo));

      loadCustomer(vm).then(function () {
        if (vm.hideHeader) {
          vm.customerContentTabIndex = 3
        }
        if (vm.initiateMessage) {
          if (vm.belongsToAccount) {
            vm.startMessage()
          }
        }
        vm.loadingCust = false
      }).catch(function () {
        vm.error = true
        vm.loadingCust = false
      })

    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
    },
    computed: {
      sortedGroups: function () {
        let vm = this;

        if (vm.groups.length > 0) {
          console.log('sort it')
          return vm.groups.sort(function (group1, group2) {
            if (group1.LastMessageTimeToken > 0 && group2.LastMessageTimeToken > 0 && group1.LastMessageTimeToken !==
              group2.LastMessageTimeToken)
              return group1.LastMessageTimeToken > group2.LastMessageTimeToken ? -1 : 1;
            else
              return group1.Timetoken > group2.Timetoken ? -1 : 1;
          });
        } else {
          return []
        }
      },
      showSocial: function () {
        let vm = this;
        if (vm.FacebookURL || vm.LinkedinURL || vm.PinterestURL || vm.TwitterURL) return true
        return false
      },
      selectedGroup: function () {
        let vm = this;

        let group;

        if (vm.selectedGroupId && vm.groups.length > 0) {
          console.log(vm.groups)
          let grpIndx = vm.groups.findIndex(function (element) {
            return element.GroupId == vm.selectedGroupId
          })
          return vm.groups[grpIndx]
        }

      },
      belongsToAccount: function () {
        let vm = this;

        if (vm.user) {
          if (vm.user.AccountID == vm.user.ViewAccountID) return true
        }
        return false
      }
    }
  };


  function loadCustomer(vm) {
    return new Promise((resolve, reject) => {
      CustomerAPIClient.getCustomerIds(vm.customerObj).then(function (data) {
        vm.assosciatedIds = Object.assign({}, data);
        CustomerAPIClient.getCustomerHeader(vm.assosciatedIds).then(function (headerData) {
          vm.customerInfo = Object.assign({}, headerData)
          vm.loading = false
          CustomerAPIClient.getCustomerGroups(vm.assosciatedIds).then(function (data) {
            data.map(function (group) {
              return generateGroupObject(group)
            })
            vm.groups = data;
            if (vm.groups.length > 0) {
              vm.selectedGroupId = vm.groups[0].GroupId
            }
            resolve()
          })
        })
      }).catch(function (error) {
        reject()
      })
    })
  }


  function generateGroupObject(group) {
    try {
      group.Messages = group.Messages || []; // Represents displayable messages (Not deleted)
      group.AllMessages = []; // Represents all messages in this group (updates/deletions)
      if (group.Messages) {
        group.Messages.map(function (element) {
          return convertToMotoMessage(element)
        })
        group.AllMessages = Object.assign([], group.Messages)
      }
      group.IsLoadingForms = false; //To handle loading of forms for a request
      group.Forms = []; //To display forms for a request

      group.LastMessageSender = null;

      if (!group.LastMessageDT && !group.LastMessageText) {
        group.LastMessageDT = group.CreateDT;
        group.LastMessageText = "";
      }

      // Set initial visibility state (prior to filtering being applied)
      group.isVisible = !group.IsHidden;

      // For composing new messages
      group.ComposedMessage = '';

      // These time tokens are .NET ticks and are used to sort groups
      group.Timetoken = moment(group.LastMessageDT).valueOf() * 10000 + EpochTicks;
      group.CreatedTimetoken = moment(group.CreateDT).valueOf() * 10000 + EpochTicks;
      group.CanSend = group.GroupMessagingType === GroupMessagingType.Direct; //Default to true if it is a new Direct message
      if (group.GroupMessagingType == GroupMessagingType.Interactive)
        group.CanSend = true;
      else if (group.GroupMessagingType == GroupMessagingType.Broadcast && group.AdminUserIds && group.AdminUserIds.length >
        0)
        group.CanSend = group.AdminUserIds.indexOf(user.Id) >= 0;

      // These time tokens are PubNub's and are used to display unread message notifications
      //group.LastReadTimetoken = group.LastViewedTimeToken;
      //group.LastMessageTimeToken = moment(group.LastMessageDT).valueOf() * 10000;
      //if (group.LastMessageTimeToken < group.LastViewedTimeToken)
      //    group.LastMessageTimeToken = group.LastViewedTimeToken;
      // group.HasNewMessages = false;

      //PubNub properties to manage messages
      group.PubnubId = convertIdToPubNubKind(group.GroupId);
      if (group.Messages.length > 0) {
        group.StartTimetoken = (group.Messages[0].Timetoken - 1)
      } else group.StartTimetoken = 0

      group.EndTimetoken = 0;
      group.HasMoreMessages = group.GroupId ? true : false; //To identify if the group has more messages to fetch
      group.FetchingMessages = false; //To identify if the PubNub client is currently fetching messages
      group.Iteration = 0; //Represents the number of calls to Pubnub to fetch displayable messages
      group.ErrorFetchingMessages = false;
      //Generate workflow related params
      group.WorkflowInstanceStatusText = null;
      group.PlatformName = null;
      if (group.ChannelType == ChannelType.Request) {
        if (group.WorkflowInstanceStatus > 0) {
          if (group.WorkflowInstanceStatus == WorkflowInstanceStatus.New)
            group.WorkflowInstanceStatusText = "New";
          else if (group.WorkflowInstanceStatus == WorkflowInstanceStatus.InProgress)
            group.WorkflowInstanceStatusText = "In Progress";
          else if (group.WorkflowInstanceStatus == WorkflowInstanceStatus.Overdue)
            group.WorkflowInstanceStatusText = "Overdue";
        }

        // NOT SURE THIS IS NECESSARY

        // if (group.PlatformId > 0 && user.AllowedStores && user.AllowedStores.length > 0) {
        //   var platform = user.AllowedStores.find(function (store) {
        //     return store.AccountPlatformID == group.PlatformId;
        //   });
        //   if (platform && platform.AccountPlatformID > 0)
        //     group.PlatformName = platform.Name;
        // }
      }

      group.MarkGroupAsViewedInProgress = false; //To prevent multiple calls to API for marking a group as read

      group.Members = group.Members || [];

      return group;
    } catch (err) {
      console.log("Error generating group object", err);
      return null;
    }
  }

  async function handleRegularMessage(message, groups) {
    var pubnubId = message.channel;
    var motofuzeId = convertIdToMotoKind(message.channel)
    var message = message
    let group;
    let groupIndex = groups.findIndex(function (element) {
      console.log(motofuzeId)
      return element.GroupId == motofuzeId
    })

    if (groupIndex > -1) {
      group = groups[groupIndex]
    } else return;

    if (pubnubId == convertIdToPubNubKind(group.GroupId)) {
      let motoMsg = await convertToMotoMessage(message)
      await addMessageToGroup(motoMsg, group)
      group = await sortGroupMessages(group)
      groups.splice(groupIndex, 1, group)
    }
  }

  async function handleControlMessage(message, groups, currentUser) {
    var notificationType = null;
    var notification = null;
    var group;

    if (message && message.msg) //Via listener
      notification = message.msg;
    if (message.rtid)
      notificationType = message.rtid;

    if (notification && notificationType) {
      if ((notificationType === NotificationType.AccountUserResponse) || (notificationType === NotificationType.UserResponse)) {
        //COME BACK TO THIS
      } else if (notificationType === NotificationType.GroupResponse ||
        notificationType === NotificationType.GroupCreatedResponse ||
        notificationType === NotificationType.GroupUpdatedResponse ||
        notificationType === NotificationType.GroupAddUserResponse ||
        notificationType === NotificationType.UserNotification ||
        notificationType === NotificationType.GroupFavoriteResponse ||
        notificationType === NotificationType.GroupMessageResponse) {

        var group = notification;
        if (typeof (group) != 'object')
          group = JSON.parse(group);
        if (!group)
          return;


        if (group.GroupType != GroupType.CrmCustomer) return

        await addGroupToList(groups, group)
      } else if (notificationType == NotificationType.GroupRemoveUserResponse) {
        let theGrp;
        let removedGrp = groups.findIndex(function (element) {
          return element.GroupId == notification.GroupId
        })
        if (removedGrp > -1) {
          theGrp = await removeUserFromGroup(groups[removedGrp], currentUser.Id)
          groups.splice(removedGrp, 1, theGrp)
        }

      }
    }
  }

  async function removeUserFromGroup(group, userId) {
    console.log(group)
    if (group.Users) {
      await group.Users.splice(group.Users.indexOf(function (element) {
        return element.Id == userId
      }), 1)
    }

    if (group.UserIds) {
      await group.UserIds.splice(group.UserIds.indexOf(function (element) {
        return element == userId
      }), 1)
    }

    return group
  }

  function updateGroupLastMessage(group) {
    if (group.Messages && group.Messages.length > 0) {
      group.Messages.sort(function (message1, message2) {
        return message1.CreatedTimetoken > message2.CreatedTimetoken ? 1 : -1;
      });

      //Mark any previous unread messages as read before we check if there are any new unread messages
      for (var msg of group.Messages) {
        if (msg.IsFirstUnread)
          msg.IsFirstUnread = false;
      }

      var lastMessage = group.Messages[group.Messages.length - 1];
      //There is an issue with the group.LastMessageTimeToken set by API
      //It sometimes returns .NET ticks instead of Unix timestamp
      //Update it with the last message's timetoken instead
      // if (lastMessage.Timetoken >= group.LastMessageTimeToken) {
      group.LastMessageTimeToken = lastMessage.Timetoken;
      group.LastMessageText = lastMessage.MessageText;
      group.LastMessageDT = lastMessage.CreatedUtc;
      group.LastMessageSender = lastMessage.Sender;
      // }

      return group

      // //If the current user sent the last message in this group, mark all messages as read
      // if (lastMessage.SenderId == store.getters.user.Id)
      //     store.commit('markMessagesAsRead', group.GroupId);

      // //Handle unread status
      // if (lastMessage.SenderId == store.getters.user.Id && group.MessageBadgeCount > 0) {
      //     //Mark this group as viewed
      //     store.commit('markGroupAsViewed', group.GroupId);
      // } else if (group.MessageBadgeCount > 0 && group.LastMessageTimeToken > group.LastViewedTimeToken) {
      //     var firstUnreadMessage = group.Messages.find(function (msg) {
      //         return msg.Timetoken > group.LastViewedTimeToken && msg.SenderId != store.getters.user.Id;
      //     });
      //     if (firstUnreadMessage)
      //         firstUnreadMessage.IsFirstUnread = true;
      // }
    }
  }


  async function addGroupToList(groups, group) {
    var existingGroup = null;
    if (group.GroupId && groups && groups.length > 0)
      existingGroup = groups.find(function (grp) {
        return grp.GroupId == group.GroupId;
      });


    //If we already have the latest group information, return
    if (existingGroup && existingGroup.Uid && group.Uid && existingGroup.Uid > group.Uid) {
      // console.log("GroupId: " + group.GroupId);
      // console.log("Existing Uid: " + existingGroup.Uid);
      // console.log("Incoming Uid: " + group.Uid);
      return;
    }

    group = generateGroupObject(group);

    // //Update group members
    // store.commit('updateGroupMembers', group);

    if (group.Messages && group.Messages.length > 0) {
      var motoMessages = group.Messages.splice(0, group.Messages.length);
      for (var msg of motoMessages) {
        var motoMSG = await convertToMotoMessage(msg);
        await addMessageToGroup(motoMSG, group);
      }
    }

    if (existingGroup && existingGroup.Messages && existingGroup.Messages.length > 0) {
      for (var msg of existingGroup.Messages)
        await addMessageToGroup(msg, group);
    }
    //Update the last message in this group
    group = await updateGroupLastMessage(group);

    if (group && group.GroupId) {
      if (existingGroup) {
        //Copy existing values for the group
        group.ComposedMessage = existingGroup.ComposedMessage;
        group.MarkdownMessage = existingGroup.MarkdownMessage;
        group.HasMoreMessages = existingGroup.HasMoreMessages;
        group.FetchingMessages = existingGroup.FetchingMessages;
        group.StartTimetoken = existingGroup.StartTimetoken;
        group.EndTimetoken = existingGroup.EndTimetoken;
        group.ScrollToMessageId = existingGroup.ScrollToMessageId;
        group.PinnedMessages = existingGroup.PinnedMessages;
        group.LoadingPinnedMessages = existingGroup.LoadingPinnedMessages;
        group.HasPinnedMessages = existingGroup.HasPinnedMessages;
        if (existingGroup.Users) {
          group.Users = existingGroup.Users

        }
        // group.FavoriteMessagesCount = existingGroup.FavoriteMessagesCount;

        var index = groups.findIndex(function (element) {
          return element.GroupId == group.GroupId
        });

        groups.splice(index, 1, group);

        // index = filteredGroups.indexOf(existingGroup);
        // if (index >= 0)
        //     filteredGroups.splice(index, 1, group);

      } else {
        groups.push(group);
      }
    }
  }

  function sortGroupMessages(group) {
    let sort = group.Messages.sort(function (message1, message2) {
      return message1.CreatedTimetoken > message2.CreatedTimetoken ? 1 : -1;
    });

    group.Messages = sort;

    return group
  }

  function addMessageToGroup(motoMSG, group) {
    try {
      if (!motoMSG || !motoMSG.MessageId || !motoMSG.Messages || motoMSG.Messages.length === 0)
        return;

      if (!group.Messages || group.Messages.length == 0)
        group.Messages = [];

      var existingMSG = group.AllMessages.find(function (message) {
        return message.MessageId === motoMSG.MessageId;
      });

      //Update the message in all messages
      if (existingMSG) {
        //If two messages with the same id exist, display the one with the latest timestamp
        if (existingMSG.Timetoken <= motoMSG.Timetoken) {
          var index = group.AllMessages.indexOf(existingMSG);
          group.AllMessages.splice(index, 1, motoMSG);
        } else if (existingMSG.NoPubnubTimestamp)
          existingMSG.AttachmentFile = motoMSG.AttachmentFile;
      } else
        group.AllMessages.push(motoMSG);

      //Update the message in displayed messages
      if (existingMSG) {
        //If two messages with the same id exist, display the one with the latest timestamp
        if (existingMSG.Timetoken <= motoMSG.Timetoken) {
          var msgIndex = group.Messages.findIndex(msg => msg.MessageId == motoMSG.MessageId);
          if (msgIndex >= 0) {
            if (motoMSG.IsDeleted)
              group.Messages.splice(msgIndex, 1);
            else
              group.Messages.splice(msgIndex, 1, motoMSG);
          } else if (!motoMSG.IsDeleted)
            group.Messages.push(motoMSG);
        }
      } else if (!motoMSG.IsDeleted)
        group.Messages.push(motoMSG);
    } catch (err) {
      console.log(err);
    }
  }

</script>


<style lang="scss" scoped>
  #overlay {
    background: $gray-lt;
    opacity: .5;
    color: #666666;
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 5000;
  }

  .nav.nav-tabs .nav-link {
    color: $blue-lt;
    font-weight: 400; // font-size: 16px;
    // padding-bottom: 4px;
    transition: none;
  }

  .nav-tabs {
    border-bottom: 1px solid $gray-lt;
  }

  .nav-tabs .nav-link {
    border: none;
    padding: .5em 0;
    img {
      height: 24px;
      width: auto;
    }
  }

  .nav-tabs .nav-link.active {
    border-bottom: 5px solid $blue-lt; // border-bottom: 3px solid $blue-lt;
    color: $charcoal;
  }

  .panel-level-tabs {
    background: $gray-lt;

    .nav-item.title-tab {
      .nav-link {
        padding: 0.7rem 1rem 0.3rem 1rem;
      }
    }

    .nav-item {
      border-radius: $Border-radius;

      .nav-link {
        border-radius: $Border-radius $Border-radius 0 0; //  border-color: transparent;
        background: $gray-xlt;
        margin-right: 2px;
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-height: 43px;
        width: auto;
        padding: .5rem 1rem;

        b {
          font-size: 18px;
          margin: 0 3px;
        }
        &.active {
          background: $white;
          border-color: transparent;
        }
      }
    }
  }

  .Mobile {
    .hidden-mobile {
      display: none;
    }
    .panel-level-tabs {
      background: $gray-lt;

      .title-tab {
        .nav-link {
          border-radius: 10px 0 0 0;
          color: $charcoal;

        }
      }
      .nav-item {
        border-radius: $Border-radius;

        .nav-link {
          border-radius: 0 0; //  border-color: transparent;
          background: $blue-lt;
          color: $white;
          margin-right: 1px;
          font-weight: 500;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 45px;
          width: auto;
          b {
            font-size: 18px;
            margin: 0 3px;
          }
          &.active {
            color: $charcoal;
            background: $white;
            border-color: transparent;
          }

        }
        &:first-child>.nav-link {
          border-radius: 10px 0 0 0;
        }
        &:last-child>.nav-link {
          border-radius: 0 10px 0 0;
        }
      }
    }

  }

  /* End Review Builder Cards */

  .is-collapsed {
    div {
      transition: $Transition-speed;
      display: none;
    }
  }

  .responsive-btns {
    .btn {
      font-size: 0.8em;
      img {
        height: 30px;
        width: auto !important;
      }
    }
  }

  @media (max-width:800px) {
    .responsive-tabs {
      .nav-tabs .nav-link {
        border: none;
        padding: 0;
        font-size: 0.8em;
        img {
          height: 18px;
          width: auto;
        }
      }
      .nav-tabs .nav-link.active {
        border-bottom: 5px solid $blue-lt; // border-bottom: 3px solid $blue-lt;
        color: $charcoal;
      }
    }
    .responsive-btns {
      .btn {
        font-size: 0.8em;
        img {
          height: 18px !important;
          width: auto !important;
        }
      }
    }
  }


  #customer-profile {
    height: calc( #{$Panel-height} - 45px);
    border-radius: 0 10px 0 0; // overflow:hidden;
    background-color: $white;
  }

  .Mobile {
    #customer-profile {
      height: calc( 100vh - 45px); // min-height: calc( 100vh - 75px);
    }
  }

  .Dealsheet {
    #customer-profile {
      height: calc( 100vh);
    }
    .top-32 {
      top: 0px;
    }
  }

  @media (min-height:800px) {
    #customer-profile {
      // height: calc( 100vh - 45px);
      // min-height: calc( 100vh - 75px);
    }
    .Mobile {
      #customer-profile {
        height: calc( 100vh - 45px);
      }
    }

  }

  .top-32 {
    top: 32px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/CustomerProfile.vue